import { render } from "./CatalogItem_Dialog.vue?vue&type=template&id=4ff65f88&scoped=true&ts=true"
import script from "./CatalogItem_Dialog.vue?vue&type=script&lang=ts"
export * from "./CatalogItem_Dialog.vue?vue&type=script&lang=ts"

import "./CatalogItem_Dialog.vue?vue&type=style&index=0&id=4ff65f88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff65f88"]])

export default __exports__